import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=cb8a4fca&scoped=true"
import script from "./ModalView.vue?vue&type=script&lang=js"
export * from "./ModalView.vue?vue&type=script&lang=js"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=cb8a4fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8a4fca",
  null
  
)

export default component.exports